export default "__VITE_ASSET__Bihh7wen__"